import { render, staticRenderFns } from "./DropzoneInvitationDoc.vue?vue&type=template&id=29877c29&"
import script from "./DropzoneInvitationDoc.vue?vue&type=script&lang=js&"
export * from "./DropzoneInvitationDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports